import { endOfDay, parse } from "date-fns";
import { InstoreTemplate } from "../models/instoreTemplate";

// The backend stores a template's `from`/`until` as datetimes, but the app only
// ever fills in a *date* — so both come back as midnight ("dd/MM/yyyy 00:00").
// `from` at midnight is the correct start of the window, but `until` at midnight
// would make the last day exclusive: at 09:00 on the until-date "now" is already
// past 00:00 and the template drops out. The client asked for `until` to be
// inclusive (a template valid "until 30/09" must still work on 30/09), so the
// window ends at the END of the until-day.
//
// Returns null when either date is missing or unparseable.
export function getTemplateDateWindow(
  template: Pick<InstoreTemplate, "from" | "until">,
): { from: Date; until: Date } | null {
  if (!template.from || !template.until) return null;

  const from = parse(template.from, "dd/MM/yyyy HH:mm", new Date());
  const until = parse(template.until, "dd/MM/yyyy HH:mm", new Date());
  if (isNaN(from.getTime()) || isNaN(until.getTime())) return null;

  return { from, until: endOfDay(until) };
}
